import React, { memo, useReducer, useState } from "react";
import { AdvanceFilter, Table, Text } from "components/src";
import { useGetChatGetAllMessages, useNavigation } from "core";
import { useTranslation } from "react-i18next";
import {  TablePaginationConfig} from "antd";
import { initialState,reducer, updateCurrentPage } from "./store";

interface Props {}

const MessagesReport = memo<Props>(() => {
  
  // const { _navigate, _navigateWithParams } = useNavigation();
  const { i18n } = useTranslation();
  const [
    { currentPage },
    dispatch,
  ] = useReducer(reducer, initialState);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const { data: { data } = {}, isFetching } = useGetChatGetAllMessages({pageNumber:currentPage,pageSize:"10"});
  
  const columns: any = [
    {
      title: i18n.t("id"),
      key: "id",
      dataIndex: "id",

      render: (text: any) => <Text>{text}</Text>,
    },
    {
      title: i18n.t("date"),
      dataIndex: "created_at",
      key: "created_at",
      render: (text: any) =>  text?<Text>{text}</Text>:"null",
    },
    {
      title: i18n.t("sender"),
      dataIndex: "sender",
      key: "sender",
      render: (text: any) => text?<Text>{text?.name_and_family}</Text>:"null",
    },
    // {
    //   title: i18n.t("receiver"),
    //   dataIndex: "receiver",
    //   key: "receiver",
    //   render: (text: any) => <Text>{text}</Text>,
    // },
    // {
    //   title: i18n.t("operation"),
    //   key: "operation",
    //   dataIndex: "operation",
    //   render: (_: any, record: any) => (
    //     <Flex align="center" justify="start">
    //       <Space>
    //         <Button
    //           title={i18n.t("details")}
    //           color="warning"
    //           onClick={() => {
    //             _navigateWithParams(routesName.DASHBOARD, {
    //               id: record.id,
    //             });
    //           }}
    //         >
    //           <PiNotebookLight size={20} />
    //         </Button>
    //         <Button
    //           title={i18n.t("edit")}
    //           onClick={() => {
    //             _navigateWithParams(routesName.EDITUSER, {
    //               id: record.id,
    //             });
    //           }}
    //         >
    //           <CiEdit size={20} />
    //         </Button>

    //         <Switch
    //           checked={record.is_active}
    //           onChange={
    //             () => {}
    //             // update({
    //             //   campaign: record.id,
    //             //   requestBody: {},
    //             // })
    //           }
    //           checkedChildren={
    //             <Space style={{ marginTop: 3 }}>
    //               <MdOutlineRemoveDone size={15} />
    //             </Space>
    //           }
    //           unCheckedChildren={
    //             <Space>
    //               <IoCheckmarkDoneSharp size={15} />
    //             </Space>
    //           }
    //         />
    //         <Button
    //           title={i18n.t("addNumber")}
    //           color="warning"
    //           onClick={() => {
    //             _navigateWithParams(routesName.DASHBOARD, {
    //               id: record.id,
    //             });
    //           }}
    //         >
    //           <MdOutlineAddIcCall size={20} />
    //         </Button>
    //         <Button
    //           title={i18n.t("delete")}
    //           color="danger"
    //           onClick={() => {
    //             // dispatch(handleModal(true));
    //             // dispatch(setId(record.id));
    //           }}
    //           //   disabled={isPending}
    //         >
    //           <RiDeleteBin6Line size={20} />
    //         </Button>
    //       </Space>
    //     </Flex>
    //   ),
    // },
  ];

  // const onAdvanceFilterChange = (filterValues: any) => {
    // dispatch(handleFiltering(filterValues));
  // };

  const handlePageChange = (current_page: number) => {
    dispatch(updateCurrentPage(current_page));
  };

  const pagination: TablePaginationConfig = {
    current: data?.meta?.current_page,
    pageSize: 10,
    total: data?.totalCount,
    onChange: handlePageChange,
    showSizeChanger: false,
    position: ["bottomRight"],
  };

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    console.log('selectedRowKeys changed: ', newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };
//   const isLoading = isFetching;
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  return (
    <>
      <Table
      rowSelection={rowSelection}
        // filterComponent={
        //   <AdvanceFilter
        //     setAdvanceFilter={onAdvanceFilterChange}
        //     nameField={true}
        //     activeField={true}
        //     creatorField={true}
        //     serverField={true}
        //   />
        // }
        // loading={isLoading}
        // excelIcon={
        //   <Button
        //     title={i18n.t('downloadCampaigns')}
        //     isLoading={isCampaignNumberStatisticLoading}
        //     onClick={handleDownload}
        //   >
        //     <RiFileExcel2Line
        //       size={25}
        //       color={colors.green01}
        //       onClick={handleDownload}
        //       title={i18n.t('stats')}
        //     />
        //   </Button>
        // }
        {...{ columns }}
        dataSource={data?.messages?.filter((item:any)=>{return item.sender!=null})}
        pagination={pagination}
      ></Table>
     </>
  );
});
export { MessagesReport };
